import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-dfa79e8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pagos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "pagos-content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Pagos Pendientes", -1 /* HOISTED */));
const _hoisted_5 = { class: "filtros-container" };
const _hoisted_6 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner" }, null, -1 /* HOISTED */));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "pagos-table" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "ID Pedido"),
        /*#__PURE__*/ _createElementVNode("th", null, "Cliente"),
        /*#__PURE__*/ _createElementVNode("th", null, "WhatsApp"),
        /*#__PURE__*/ _createElementVNode("th", null, "Método"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha"),
        /*#__PURE__*/ _createElementVNode("th", null, "Monto Total"),
        /*#__PURE__*/ _createElementVNode("th", null, "Comprobante"),
        /*#__PURE__*/ _createElementVNode("th", null, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_11 = ["href"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "actions-column" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "no-results-message"
}, " No se encontraron pagos con esos criterios. ", -1 /* HOISTED */));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = { class: "modal-header" };
const _hoisted_20 = { class: "modal-body" };
const _hoisted_21 = ["src"];
import { ref, onMounted, computed } from "vue";
import { formatCurrency } from "@/utils/formatPrice";
import Swal from "sweetalert2";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/HeaderDashboard.vue";
import { PagoService } from "@/services/PagoService";
import { config } from "@/config";
import { EyeIcon, CheckCircleIcon, XIcon } from "lucide-vue-next";
import { hasPermission } from '@/store/userStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const pagos = ref([]);
        const isLoading = ref(false);
        const modalVisible = ref(false);
        const comprobanteSeleccionado = ref(null);
        const busqueda = ref("");
        const filtroEstado = ref("");
        // Computed para filtrar pagos según búsqueda y estado
        const pagosFiltrados = computed(() => {
            return pagos.value.filter((p) => {
                const matchesBusqueda = p.nombre.toLowerCase().includes(busqueda.value.toLowerCase()) ||
                    p.pedido.codigoPedido.toLowerCase().includes(busqueda.value.toLowerCase()) ||
                    p.whatsapp.includes(busqueda.value);
                const matchesEstado = filtroEstado.value
                    ? p.estado.toLowerCase() === filtroEstado.value.toLowerCase()
                    : true;
                return matchesBusqueda && matchesEstado;
            });
        });
        const formatFecha = (fecha) => {
            const opciones = { day: "2-digit", month: "long", year: "numeric" };
            return new Date(fecha).toLocaleDateString("es-ES", opciones);
        };
        const cargarPagos = async () => {
            isLoading.value = true;
            try {
                const response = await PagoService.obtenerPagosPendientes();
                if (response.exito) {
                    pagos.value = response.datos || [];
                }
                else {
                    Swal.fire("Error", response.errores || "No se pudieron cargar los pagos", "error");
                    pagos.value = [];
                }
            }
            catch (error) {
                Swal.fire("Error", error.message || "Ocurrió un error al cargar los pagos", "error");
                pagos.value = [];
            }
            finally {
                isLoading.value = false;
            }
        };
        const limpiarFiltros = () => {
            busqueda.value = "";
            filtroEstado.value = "";
        };
        onMounted(() => {
            cargarPagos();
        });
        const verComprobante = (pago) => {
            comprobanteSeleccionado.value = `${config.API_URL}${pago.rutaComprobante}`;
            modalVisible.value = true;
        };
        const cerrarModal = () => {
            modalVisible.value = false;
        };
        const verificarPago = async (pagoId, aceptar) => {
            const accion = aceptar ? "aprobar" : "rechazar";
            const confirmacion = await Swal.fire({
                title: `¿Deseas ${accion} este pago?`,
                text: `Esta acción cambiará el estado del pago.`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: `Sí, ${accion}`,
                cancelButtonText: "Cancelar",
            });
            if (!confirmacion.isConfirmed)
                return;
            isLoading.value = true;
            try {
                const response = await PagoService.verificarPago(pagoId, aceptar);
                if (response.exito) {
                    Swal.fire("Éxito", `El pago fue ${aceptar ? "aprobado" : "rechazado"} correctamente`, "success");
                    await cargarPagos();
                }
                else {
                    Swal.fire("Error", response.errores || "No se pudo procesar la solicitud", "error");
                }
            }
            catch (error) {
                Swal.fire("Error", error.message || "Ocurrió un error al procesar el pago", "error");
            }
            finally {
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Header "),
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Sidebar "),
                    _createVNode(Sidebar),
                    _createCommentVNode(" Contenido principal "),
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createCommentVNode(" Filtros "),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((busqueda).value = $event)),
                                placeholder: "Buscar por cliente, pedido o WhatsApp...",
                                class: "input-busqueda"
                            }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, busqueda.value]
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-limpiar",
                                onClick: limpiarFiltros
                            }, "Limpiar")
                        ]),
                        _createCommentVNode(" Loader "),
                        (isLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Tabla "),
                                _createElementVNode("div", null, [
                                    _createElementVNode("table", _hoisted_9, [
                                        _hoisted_10,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagosFiltrados.value, (pago) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: pago.pagoId
                                                }, [
                                                    _createElementVNode("td", null, "#" + _toDisplayString(pago.pedido.codigoPedido), 1 /* TEXT */),
                                                    _createElementVNode("td", null, _toDisplayString(pago.nombre), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("a", {
                                                            href: `https://wa.me/${pago.whatsapp}`,
                                                            target: "_blank",
                                                            class: "whatsapp-link"
                                                        }, _toDisplayString(pago.whatsapp), 9 /* TEXT, PROPS */, _hoisted_11)
                                                    ]),
                                                    _createElementVNode("td", null, _toDisplayString(pago.metodoPago), 1 /* TEXT */),
                                                    _createElementVNode("td", null, _toDisplayString(formatFecha(pago.fechaPago)), 1 /* TEXT */),
                                                    _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(pago.pedido.total)), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("button", {
                                                            class: "btn btn-ver",
                                                            onClick: ($event) => (verComprobante(pago))
                                                        }, [
                                                            _createVNode(_unref(EyeIcon), { size: 18 })
                                                        ], 8 /* PROPS */, _hoisted_12)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_13, [
                                                        (_unref(hasPermission)('PAY_APPROVE'))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "btn btn-success",
                                                                title: "Aprobar",
                                                                onClick: ($event) => (verificarPago(pago.pagoId, true))
                                                            }, [
                                                                _createVNode(_unref(CheckCircleIcon), { size: 18 }),
                                                                _createTextVNode(" Aprobar ")
                                                            ], 8 /* PROPS */, _hoisted_14))
                                                            : _createCommentVNode("v-if", true),
                                                        (_unref(hasPermission)('PAY_APPROVE'))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                class: "btn btn-danger",
                                                                title: "Rechazar",
                                                                onClick: ($event) => (verificarPago(pago.pagoId, false))
                                                            }, [
                                                                _createVNode(_unref(XIcon), { size: 18 }),
                                                                _createTextVNode(" Rechazar ")
                                                            ], 8 /* PROPS */, _hoisted_15))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */)),
                                            (pagosFiltrados.value.length === 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, _hoisted_18))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    ])
                ]),
                _createCommentVNode(" Modal para ver comprobante "),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (modalVisible.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: cerrarModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-content",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                            class: "btn-close",
                                            onClick: cerrarModal
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("img", {
                                            src: comprobanteSeleccionado.value || undefined,
                                            alt: "Comprobante",
                                            class: "comprobante-img"
                                        }, null, 8 /* PROPS */, _hoisted_21)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
